import { generatePath } from "@routes/utils";

const pathBase = `/auth/otp/2fa/`;

export const twoFa = {
  post: () => generatePath(pathBase, null),
};
